/**
 * Whether a level has anything to do with git.
 *
 * A level that starts with a repository does, and so does one that teaches a
 * `git.*` skill without one (level 2 starts empty and the learner runs
 * `git init`). Everything else — level 0's first commands, level 1's search,
 * the processes, HTTP and SQL levels of Act II — never draws a commit, so the
 * graph, the "no repository yet" chip and a sentence about "the repository you
 * leave" are noise there, and on level 0 they are the first screen a newcomer
 * sees.
 */
export function usesGit(mission: { expects_repo: boolean; mastery_tags: readonly string[] }): boolean {
  return mission.expects_repo || mission.mastery_tags.some((tag) => tag.startsWith('git.'));
}
